import { memo } from 'react';

import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { uiImages } from '@/react/components/content/registry/data';

import { AthleteSlug } from './athleteData';

/**
 * Register the Bureau of Adventure Athletes component.
 * Displays athlete profiles dynamically based on the athlete slug.
 */
const register = (): void => {
  Builder.registerComponent(memo(dynamic(async () => import('./index'))), {
    name: 'AthleteContent',
    image: uiImages.cubeImage,
    noWrap: true,
    inputs: [
      {
        name: 'athlete',
        type: 'text',
        defaultValue: AthleteSlug.AlvinDedeaux,
        enum: Object.values(AthleteSlug),
        helperText: 'Select the athlete to display on this page'
      }
    ]
  });
};

export default register;
